export default __webpack_public_path__ + "static/media/jungle_speed.b059ecf8.png";